import { atomWithHash } from '@/atoms/atomWithHash';
import { atom } from 'jotai';

export interface CreateTemplateModalState {
  open: boolean;
  isFrom?:
    | 'document_modal'
    | 'note_structure_modal'
    | 'existing_note_modal'
    | 'template_table'
    | 'create_template_modal'
    | 'ask_ai';
  /** Analytics-only: the prompt behind an `ask_ai` creation. */
  aiCommandText?: string;
}

// The type moved into `@heidi/templates/contracts` (ARCFE-1030) so the update
// mutation can name it headlessly. Imported for this module's own atoms AND
// re-exported, so all ten importers of this path keep resolving.
import { type EditTemplateType } from '@heidi/templates/contracts';

// `export type { … }`, not `export { type … }`: react-refresh reads the
// DECLARATION's export kind, so the inline-modifier form counts as a value
// export and makes every atom in this file a fast-refresh violation.
export type { EditTemplateType };

export const createTemplateModalAtom = atom<CreateTemplateModalState>({
  open: false,
});

export const withAiTemplateContentAtom = atom({
  isStreaming: false,
});

export const editTemplateModalOpenAtom = atom<EditTemplateType>(null);

export const editExistingNoteModalOpenAtom = atomWithHash<EditTemplateType>(
  'editExistingNoteModalOpenAtom',
  null,
  {
    // to replace the current URL without adding a new entry to the history
    setHash: 'replaceState',
  }
);
